import styled from 'styled-components';
import { Alert } from '@origin-digital/ods-core';

/**
 * This is a hack to fix an IE issue with Alert.
 * Alert has code to set MuiAlert-message to 100% width.
 *
 * However, the actual className is MuiAlert-message-<index> as a result the css doesn't match.
 * The code below applied 100% width but fuzzy match the className
 *
 */
export const IEFixedAlert: any = styled(Alert)`
  & [class^='MuiAlert-message'] {
    width: 100%;
  }
`;
